"use strict";function rolesPicker$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.rolesPicker$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.contact.rolesPicker";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"6.3.16"},_a[ddSdk_1.ENV_ENUM.android]={vs:"6.3.16"},_a)),exports.rolesPicker$=rolesPicker$,exports.default=rolesPicker$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/contact/rolesPicker.js
// module id = 936
// module chunks = 106